import { render, staticRenderFns } from "./AgingOfReceivablesAndLiabilities.vue?vue&type=template&id=466f26ce&"
import script from "./AgingOfReceivablesAndLiabilities.vue?vue&type=script&lang=js&"
export * from "./AgingOfReceivablesAndLiabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports